import {
  AfterContentInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { FrontHeader } from '@app/src/app/components/front-header/front-header';
import { RenderHtml } from '@ckmk/angular';

@Component({
  selector: 'rse',
  standalone: true,
  imports: [FrontHeader, RenderHtml],
  templateUrl: './rse.html',
  styleUrl: './rse.scss',
  encapsulation: ViewEncapsulation.None,
})
export class Rse implements OnInit, OnChanges, OnDestroy, AfterContentInit {
  protected readonly self = inject<ElementRef<HTMLElement>>(ElementRef);

  public constructor() {}

  public ngOnInit() {}

  public ngOnChanges(changes: SimpleChanges) {}

  public ngOnDestroy() {}

  public ngAfterContentInit() {}
}
